var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PHILIPPINES_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.1909 0.664062H0.626953V10.4531H34.1909V0.664062Z",
    fill: "#2534A4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.1909 10.4531H0.626953V20.2421H34.1909V10.4531Z",
    fill: "#BC0030"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.626953 0.664062V20.2421L17.668 10.4531L0.626953 0.664062Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.93024 18.3594L2.17426 17.9184L1.52325 18.5084L1.70923 17.6524L0.947266 17.2194L1.82025 17.1294L1.99823 16.2734L2.35022 17.0744L3.22125 16.9774L2.56622 17.5634L2.93024 18.3594Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M5.22681 8.68423L4.58783 7.58624L4.21881 7.54324L5.09381 8.78525L5.22681 8.68423ZM4.72882 9.18423L3.39081 8.15326L3.33984 7.55124L3.88281 7.53125L4.99182 8.89026L4.72882 9.18423ZM4.52484 9.42224L3.4198 8.79724L3.37482 8.43423L4.62482 9.28625L4.52484 9.42224Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M6.80304 8.45731L7.13708 7.23431L6.90808 6.94531L6.63708 8.43732L6.80304 8.45731ZM6.10004 8.45731L5.89307 6.77731L6.29004 6.32031L6.68207 6.69531L6.49304 8.43732L6.10004 8.45731ZM5.78705 8.47729L5.45703 7.2543L5.68604 6.9613L5.95404 8.45731L5.78705 8.47729Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.08228 9.44485L9.1933 8.83185L9.24432 8.46884L7.9823 9.30884L8.08228 9.44485ZM7.5943 8.93384L8.66229 7.62085L9.26233 7.58984L9.2663 8.13284L7.8833 9.20685L7.5943 8.93384ZM7.36328 8.72684L8.01331 7.64084L8.38031 7.60184L7.49329 8.82886L7.36328 8.72684Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M8.27875 10.9769L9.50378 11.3129L9.79077 11.0829L8.30078 10.8099L8.27875 10.9769ZM8.28076 10.2729L9.96277 10.0659L10.4178 10.4609L10.0428 10.8559L8.30078 10.6649L8.28076 10.2729ZM8.25977 9.96091L9.48474 9.62891L9.77374 9.8559L8.28174 10.1289L8.25977 9.96091Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M7.34766 12.2234L7.99164 13.3134L8.35663 13.3564L7.47766 12.1185L7.34766 12.2234ZM7.84363 11.7195L9.18762 12.7465L9.23663 13.3445L8.69562 13.3675L7.58063 12.0125L7.84363 11.7195ZM8.04462 11.4805L9.14764 12.0974L9.19861 12.4644L7.94263 11.6165L8.04462 11.4805Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M5.77515 12.4527L5.45312 13.6797L5.68311 13.9687L5.9411 12.4727L5.77515 12.4527ZM6.48114 12.4487L6.69812 14.1287L6.30914 14.5897L5.91113 14.2147L6.0871 12.4727L6.48114 12.4487ZM6.79315 12.4297L7.12915 13.6527L6.90411 13.9417L6.62714 12.4497L6.79315 12.4297Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M4.49994 11.4922L3.39996 12.1212L3.35297 12.4882L4.60095 11.6252L4.49994 11.4922ZM4.99792 11.9962L3.94891 13.3242L3.35095 13.3672L3.33496 12.8242L4.70392 11.7302L4.99792 11.9962ZM5.23096 12.1992L4.59796 13.3012L4.23096 13.3402L5.09991 12.0982L5.23096 12.1992Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M4.28339 9.94901L3.05835 9.625L2.7674 9.85199L4.26337 10.114L4.28339 9.94901ZM4.28735 10.652L2.60938 10.871L2.15039 10.48L2.52136 10.082L4.26337 10.258L4.28735 10.652ZM4.30939 10.965L3.08636 11.301L2.79535 11.074L4.28735 10.797L4.30939 10.965Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000129179549651735180710000005311115222399639171__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_42613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000004528079098547593730000010532559200101641892_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M6.28278 8.39062C7.42178 8.39062 8.34778 9.31264 8.34778 10.4536C8.34778 11.5946 7.42178 12.5236 6.28278 12.5236C5.14178 12.5236 4.21875 11.5936 4.21875 10.4536C4.21875 9.31264 5.14278 8.39062 6.28278 8.39062Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000004528079098547593730000010532559200101641892__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M13.3887 11.1645L13.9077 10.4575L13.3867 9.75049L14.2187 10.0235L14.7307 9.31348L14.7267 10.1885L15.5627 10.4535L14.7267 10.7195L14.7317 11.5985L14.2227 10.8875L13.3887 11.1645Z",
    fill: "#F3D02F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_42613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000004528079098547593730000010532559200101641892__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M34.1909 0.664062H0.626953V20.2421H34.1909V0.664062Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M2.93024 2.3316L2.17426 2.77261L1.52325 2.18359L1.70923 3.0426L0.947266 3.47659L1.82025 3.56259L1.99823 4.4216L2.35022 3.62061L3.22125 3.7146L2.56622 3.1326L2.93024 2.3316Z",
    fill: "#F3D02F"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/PHILIPPINES.d461a2a6dd28e1ceb905c5a98dc14498.svg";
export { ForwardRef as ReactComponent };